import * as ko from 'knockout';
var moment = require('moment');

require('bootstrap');
require('../../../bower_components/eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min.js');

ko.bindingHandlers.datePicker =
{
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext)
    {
        // Monday is the first day of the week
        moment.updateLocale('en', {
            week: { dow: 1 }
        });

        //initialize datepicker with some optional options
        var options = {
            format: 'D MMM, YYYY',
            stepping: 5,
        };

        if( viewModel && viewModel.constructor.name === 'BroadcastEvent' && !viewModel.repeat_until() ) 
        {
            var minDate = allBindings.get('minDate');
            options.minDate = moment(viewModel.start()).add(1,'days').format('YYYY-MM-DD');
            options.useCurrent = false;
        }

        $(element).datetimepicker(options);

        //when a user changes the date, update the view model
        ko.utils.registerEventHandler(element, "dp.change", function (event)
        {
            var value = valueAccessor();
            if (ko.isObservable(value)) {
                if (event.date !== null && event.date !== false && !(event.date instanceof Date))
                    value(event.date.toDate());
                else
                    value(event.date);
            }
        });

        ko.utils.domNodeDisposal.addDisposeCallback(element, function ()
        {
            var picker = $(element).data("DateTimePicker");
            if (picker)
                picker.destroy();
        });
    },
    update: function (element, valueAccessor, allBindings, viewModel, bindingContext)
    {
        var picker = $(element).data("DateTimePicker");
        //when the view model is updated, update the widget
        if (picker)
        {
            var koDate = ko.utils.unwrapObservable(valueAccessor());

            // set moment object as new value for datetimepicker
            var date = moment(koDate, "YYYY-MM-DD");
            
            if( koDate && date.isValid() )
                picker.date(koDate);
        }
    }
};